import React from "react";
import { Box } from "@chakra-ui/layout";

interface CardOrderOrderStatusLozengeProps {
  orderStatus?: string | null;
}

export const CardOrderOrderStatusLozenge = ({
  orderStatus,
}: CardOrderOrderStatusLozengeProps) => {
  if (!orderStatus) return null;

  const status = orderStatus.trim();
  let backgroundColor = "#c4c4c4";
  switch (status) {
    case "Ordered":
      backgroundColor = "#c41836";
      break;
    case "Completed":
      backgroundColor = "#10a958";
      break;
    case "Cancelled":
      backgroundColor = "#f24e1d";
      break;
    case "Archived":
      backgroundColor = "#000000";
      break;
  }

  let textColour = status === "Incomplete" ? "black" : "white";
  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        borderRadius: "5px",
        color: textColour,
        padding: "2px 8px",
        textAlign: "center",
        textTransform: "uppercase",
        display: "inline-block",
        height: "20px",
        lineHeight: "16px",
      }}
      fontSize={"xs"}
    >
      {status}
    </Box>
  );
};
